import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './authService';

const candidateApi = axios.create({
  baseURL: `${process.env.REACT_APP_CANDIDATE_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
candidateApi.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
candidateApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear session
      authService.clearSession();

      // Redirect to login page
      window.location.href = '/candidate/login';
    }
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
candidateApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle other errors
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error.message) {
      toast.error(error.message);
    }
    // Handle 401 Unauthorized errors
    else if (error.response?.status === 401) {
      // Clear session
      authService.clearSession();

      // Redirect to login page
      window.location.href = '/candidate/login';
    }
    
    return Promise.reject(error);
  }
);

export default candidateApi;